const LAUNDRY_REQUEST_SUCCESS = "LAUNDRY_REQUEST_SUCC";
const LAUNDRY_GET_REQUEST_SUCCESS = "LAUNDRY_GET_REQUEST_SUCC";
const LAUNDRY_GET_REQUEST_FAIL = "LAUNDRY_GET_REQUEST_FAIL";
const LAUNDRY_REQUEST_FAIL = "LAUNDRY_REQUEST_FAIL";
const LAUNDRY_REQUEST_CONFIRM = "LAUNDRY_REQUEST_ACCE";
const LAUNDRY_GET_PRICE = "LAUNDRY_GET_PRICE";

export {
  LAUNDRY_REQUEST_SUCCESS,
  LAUNDRY_REQUEST_FAIL,
  LAUNDRY_GET_REQUEST_SUCCESS,
  LAUNDRY_GET_REQUEST_FAIL,
  LAUNDRY_REQUEST_CONFIRM,
  LAUNDRY_GET_PRICE,
};
